import loadable from '@loadable/component';

export const OrgDashboardEditVolopPageContainerLoadable = loadable(
  () => import('./OrgDashboardEditVolopPageContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardEditVolopPageContainer,
    ssr: false,
  },
);
